// extracted by mini-css-extract-plugin
module.exports = {"MobileAppObserver":"mobile-app-observer_MobileAppObserver__AK0O_"};